export const SECTIONS = [
    'Funds',
    'Equities',
    'Rates',
    'Credit',
    'Volatilities',
    'Commodities',
    'FX',
    'QIS',
    'Products',
];
export const INSTRUMENT_BUCKETS = ['Beta', 'Diversifier', 'Protection'];
export const INSTRUMENT_SUB_BUCKETS = ['Carry', 'Mean Reversion', 'Trend'];
export const INSTRUMENT_VALUE_TYPES = ['absolute', 'relative'];
export const INSTRUMENT_UNITS = ['bps', 'decimal', 'index_points', 'pct', 'unit'];
